import { SquareArrowOutUpRight } from 'lucide-react'
import { useSidepanelSide } from '../../../atoms'
import { CellHoverButtonsButton, type CellHoverButtonsButtonProps } from './button'

type CellHoverButtonsPopoutProps = Omit<CellHoverButtonsButtonProps, 'label' | 'children'>

/** One wording for the move, shared by the cluster button and the right-click menu. */
export const POPOUT_LABEL = 'Open in new window'

export function PopoutIcon() {
  const side = useSidepanelSide()
  // A panel docked right opens its windows to the left, so the arrow points
  // into the screen rather than off its edge.
  return <SquareArrowOutUpRight className={side === 'right' ? '-scale-x-100' : undefined} />
}

/**
 * Open this row's View in its own window. Key it (`key="popout"`) like any
 * cluster child. Hosts gate it on `canPopOutView`, since they need that answer
 * anyway to know whether the cluster would otherwise be empty.
 */
export function CellHoverButtonsPopout(props: CellHoverButtonsPopoutProps) {
  return (
    <CellHoverButtonsButton label={POPOUT_LABEL} {...props}>
      <PopoutIcon />
    </CellHoverButtonsButton>
  )
}
